import { IdPortenAppAuth } from '@/auth/IdPortenAppAuthV2.js'
import { FeideAppAuth } from '@/auth/FeideAppAuthV2.js'
import { CreateHypatiaJWE } from '@/lib/createJWT'
// import { IdPortenTools } from '@/lib/idPortenTools'
// import router from '@/router/'
import { UdirTools } from '@/lib/udirTools'
import { FeideTools } from '@/lib/feideTools'
import { encodeLoad, decodeLoad } from '@/lib/base64'

import { userStore } from '@/stores/userstore.js'

import router from '@/router/'

import i18n from '@/i18n/i18n-setup.js'

import jwt from 'jsonwebtoken'

import dayjs from '@/plugins/dayjs.js'
const { t } = i18n.global

import { useToast } from 'vue-toastification'

const toast = useToast()
const $i18n = i18n.global.t
var idPortenAppAuth = new IdPortenAppAuth()
var feideAppAuth = new FeideAppAuth()

// var idPorten = new IdPortenTools()

function checkURL(url, port) {
  console.log('checkURL : (' + url + ') (' + port + ')')
  let newUrl = ''
  if (port === null || port === undefined) {
    port = ''
  }
  if (url.slice(0, 5) === 'https' && port === '') {
    newUrl = url
  } else if (url.slice(0, 5) === 'https' && port !== '') {
    newUrl = url + ':' + port
  } else if (url.slice(0, 4) === 'http' && port === '') {
    newUrl = url
  } else if (url.slice(0, 4) === 'http' && port !== '') {
    newUrl = url + ':' + port
  } else if (port === '443') {
    newUrl = 'https://' + url
  } else if (port !== '') {
    newUrl = 'http://' + url + ':' + port
  } else {
    newUrl = 'http://' + url
  }
  return newUrl
}

function checkRegistryURL(url) {
  if (url === '') {
    console.info('REGISTRY URL IS NULL (%s)', url)
    /* Return a registry URL that is global for production systems */
    return 'https://registry.hypatia-learning.org/'
  }
  if (!url) {
    console.error('NO REGISTRY URL SET (%s)', url)
  }
  if (url.endsWith('/')) {
    return url
  } else {
    return url + '/'
  }
}

export const adminActions = {
  async getMunicipalityKinderGartens(municipalityNumber) {
    return new Promise((resolve) => {
      let udirTools = new UdirTools()
      udirTools.getAllKindergartens(municipalityNumber).then((kgs) => {
        //console.log('GOT KGPS (%j)', kgs)
        let kinderGartenList = []
        kgs.forEach((kg) => {
          // console.log('GOT KG (%j)', kg)
          kinderGartenList.push({
            orgnr: kg.Orgnr,
            name: kg.Navn,
            data: kg
          })
        })
        resolve(kinderGartenList)
      })
    }) // promise
  },

  setLogInProcess(loginProcess) {
    this.loginProcess = loginProcess
  },
  applyRegistryUrl(registryUrl) {
    console.log('appltRegistryUrl got called:(' + registryUrl + ')')
  },
  setRegistryUrl(rUrl) {
    let registryUrl = checkRegistryURL(rUrl)
    console.log('setRegistryUrl got called:(' + registryUrl + ')')
    // let serverUrl = payload.serverURL
    return new Promise((resolve, reject) => {
      // getURLHost(serverUrl)
      let registryServer = ''
      this.getHTTPSimpleRegistry(registryUrl + 'lsregistry/index.json')
        .then((result) => {
          console.log(
            'REGISTRY Server er: (' + JSON.stringify(result.data) + ')'
          )
          if (result.data.registry_server_port === '') {
            registryServer = checkRegistryURL(result.data.registry_server)
          } else {
            registryServer =
              result.data.registry_server +
              ':' +
              result.data.registry_server_port
          }
          localStorage.setItem('hypregistry', registryUrl)
          this.registryurl = registryUrl
          console.log(
            '>>> GETTING SERVER FROM REGISTRY (ls/lhserver) (%s)',
            registryServer + 'ls/lhserver'
          )
          this.getHTTPSimpleRegistry(
            checkRegistryURL(registryServer) + 'ls/lhserver'
          )
            .then((result) => {
              console.log('findRegistryUrl/get got:')
              console.log(result)
              // console.log(result.data)
              if (result.data.error !== undefined) {
                reject({
                  error: '*** ERROR *** no result from registry service.',
                  errormsg:
                    'The Learning Registry service need to be configured !'
                })
              }
              let serverURL = checkURL(result.data.hostname, result.data.port)
              // console.log('---- serverURL (' + serverURL + ')')
              localStorage.setItem('hypsaserver', serverURL)
              this.serverurl = serverURL
              resolve({
                success: true,
                result: serverURL
              })
            })
            .catch((error) => {
              console.error(
                '*** ERROR *** findRegistryUrl/getting lh-server info (' +
                  error +
                  ')'
              )
              reject({
                error: '*** ERROR *** findRegistryUrl/getting lh server info :',
                errormsg: error
              })
            })
        })
        .catch((error) => {
          console.error(
            '*** ERROR *** findRegistryUrl getting registry service: '
          )
          console.error(error)
          reject({
            error: '*** ERROR *** findRegistryUrl/getting registry service: ',
            errormsg: error
          })
        })
    }) // promise
  },
  pingServer() {
    return new Promise((resolve, reject) => {
      console.log('getPingServer got called:(' + this.serverurl + ')')
      let serverUrl = this.serverurl || ''
      this.getHTTP('kubeheartbeat/isalive')
        .then((result) => {
          // console.log('getPingServer er: (' + JSON.stringify(result) + ')')
          resolve(result.data)
        })
        .catch((error) => {
          console.error('*** ERROR *** getPingServer had some errors:', error)
          reject(
            new Error('*** ERROR *** getPingServer had some errors:' + error)
          )
        })
    }) // promise
  },
  setServerUrl(newServerUrl) {
    console.log('setServerGot called (%s)', newServerUrl)
    this.serverurl = newServerUrl
  },
  setLang(payload) {
    this.language = payload
  },
  async getWindowSteppers() {
    console.log('getWindowSteppers got called')
    return new Promise((resolve) => {
      let t1 = ''
      let t2 = ''
      let t3 = ''
      let t4 = ''
      let t5 = ''
      let st1 = ''
      let st2 = ''
      let st3 = ''
      let st4 = ''
      let st5 = ''
      this.geti18nTranslation('parent.stepper.step1').then((r1) => {
        t1 = r1
        this.geti18nTranslation('parent.stepper.step2').then((r2) => {
          t2 = r2
          this.geti18nTranslation('parent.stepper.step3').then((r3) => {
            t3 = r3
            this.geti18nTranslation('parent.stepper.step4').then((r4) => {
              t4 = r4
              this.geti18nTranslation('parent.stepper.step5').then((r5) => {
                t5 = r5
                this.geti18nTranslation('parent.stepper.detail1').then((r6) => {
                  st1 = r6
                  this.geti18nTranslation('parent.stepper.detail2').then(
                    (r7) => {
                      st2 = r7
                      this.geti18nTranslation('parent.stepper.detail3').then(
                        (r8) => {
                          st3 = r8
                          this.geti18nTranslation(
                            'parent.stepper.detail4'
                          ).then((r9) => {
                            st4 = r9
                            this.geti18nTranslation('parent.stepper.detail5')
                              .then((r10) => {
                                st5 = r10
                              })
                              .finally(() => {
                                console.log(
                                  '======= FINALLY getWindowSteppers (%s) (%s) (%s)',
                                  t1,
                                  t3,
                                  st5
                                )
                                resolve([
                                  {
                                    step: 1,
                                    value: 1,
                                    title: t1,
                                    subtitle: st1,
                                    editable: true,
                                    complete: false
                                  },
                                  {
                                    step: 2,
                                    value: 2,
                                    title: t2,
                                    subtitle: st2,
                                    editable: false,
                                    complete: false
                                  },
                                  {
                                    step: 3,
                                    value: 3,
                                    title: t3,
                                    subtitle: st3,
                                    editable: false,
                                    complete: false
                                  },
                                  {
                                    step: 4,
                                    value: 4,
                                    title: t4,
                                    subtitle: st4,
                                    editable: false,
                                    complete: false
                                  },
                                  {
                                    step: 5,
                                    value: 5,
                                    title: t5,
                                    subtitle: st5,
                                    editable: false,
                                    complete: false
                                  },
                                  {
                                    step: 6,
                                    value: 5,
                                    title: '',
                                    subtitle: '',
                                    editable: false,
                                    complete: false
                                  }
                                ])
                              })
                          })
                        }
                      )
                    }
                  )
                })
              })
            })
          })
        })
      })
    }) //  promise
  },
  async getWindowSchoolSteppers() {
    console.log('getWindowSchoolSteppers got called')
    return new Promise((resolve) => {
      let t1 = ''
      let t2 = ''
      let t3 = ''
      let t4 = ''
      let t5 = ''
      let st1 = ''
      let st2 = ''
      let st3 = ''
      let st4 = ''
      let st5 = ''
      this.geti18nTranslation('parent.school.step1').then((r1) => {
        t1 = r1
        this.geti18nTranslation('parent.school.step2').then((r2) => {
          t2 = r2
          this.geti18nTranslation('parent.school.step3').then((r3) => {
            t3 = r3
            this.geti18nTranslation('parent.school.detail2').then((r7) => {
              st2 = r7
              this.geti18nTranslation('parent.school.detail3').then((r8) => {
                st3 = r8
                this.geti18nTranslation('parent.school.detail4')
                  .then((r9) => {
                    st4 = r9
                    this.geti18nTranslation('parent.school.detail5')
                  })
                  .finally(() => {
                    console.log(
                      '======= FINALLY getWindowSchoolSteppers (%s) (%s) (%s)',
                      t1,
                      t3,
                      st3
                    )
                    resolve([
                      {
                        step: 1,
                        value: 1,
                        title: t1,
                        subtitle: st1,
                        editable: true,
                        complete: false
                      },
                      {
                        step: 2,
                        value: 2,
                        title: t2,
                        subtitle: st2,
                        editable: false,
                        complete: false
                      },
                      {
                        step: 3,
                        value: 3,
                        title: t3,
                        subtitle: st3,
                        editable: false,
                        complete: false
                      }
                    ])
                  })
              })
            })
          })
        })
      })
    }) //  promise
  },
  setEnvironment(payload) {
    this.environment = payload
  },
  setActiveNavItem(payload) {
    this.activenavitem = payload
  },
  setSiteLanguage(payload) {
    this.sitelanguage = payload
  },
  addTranslationMap(mapKey, mapValue) {
    // console.log('ADD TRANSLATIONS MAP (%s)', mapKey)
    this.translationMap.set(mapKey, mapValue)
  },
  async geti18nTranslation(i18nkey) {
    return new Promise((resolve) => {
      if (!i18nkey) {
        resolve('**')
      }
      // console.log('geti18nTranslation (%s)',  i18nkey)
      let text = $i18n(i18nkey)
      // console.log('geti18n text (%s)', text)
      // this.gotTranslation = false
      this.getTranslation(i18nkey, text).then((translation) => {
        //   console.log('translated (%s)',  translation)
        //  this.gotTranslation = true
        resolve(translation)
      })
    }) // promise
    //   console.log('geti18nTranslation (%s)',  this.$t(i18nkey))
  },
  async getTranslation(txtKey, text) {
    //   console.log('GET TRANSLATION got called (%s) (%s)', txtKey, text)
    return new Promise((resolve) => {
      let lang = this.sitelanguage
      if (lang === 'nb' || lang === 'en') {
        this.addTranslationMap(txtKey, text)
        resolve(text)
      }
      if (this.translationMap.has(txtKey)) {
        //    console.log('GET TRANSLATION FROM MAP (%s) (%s)', txtKey, this.translationMap.get(txtKey))
        resolve(this.translationMap.get(txtKey))
      }
      let sourceLang = 'en'
      let payload = {
        txtKey: txtKey,
        targetLang: lang,
        sourceLang: sourceLang,
        text: text
      }
      // console.log(payload)
      let pLoad = {
        mutate: encodeLoad(JSON.stringify(payload))
      }
      this.postHTTP('lhadmin/translatetext/TranslateText', pLoad)
        .then((result) => {
          //  console.log('TRANSLATION (%j)', result)
          if (result.success) {
            let resultData = result.data || {}
            let resultDgraph = resultData.dgraphresult || {}
            this.addTranslationMap(txtKey, resultDgraph.translation || text)
            resolve(resultDgraph.translation)
          } else {
            this.addTranslationMap(txtKey, text)
            resolve(text)
          }
        })
        .catch((error) => {
          console.error('admin ACTIONS GET TRANSLATION ERROR (%j)', error)
          // this.addTranslationMap(txtKey, text)
          resolve('***')
        })
    }) // promise
  },
  async idPortenLogin() {
    console.log('idPortenLogin got called !')
    return new Promise((resolve, reject) => {
      if (!this.loginProcess) {
        this.setLogInProcess(true)
        // login() // v1..
        idPortenAppAuth
          .fetchServiceConfiguration()
          .then((res) => {
            console.log(
              '=== LOGIN idPortenAppAuth.fetchServiceConfiguration() returned'
            )
            console.log(res)
            idPortenAppAuth.makeAuthorizationRequest().then((res2) => {
              console.log('makeAuthorizationRequest returned (' + res2 + ')')
              //            idPortenAppAuth.checkForAuthorizationResponse()
              this.setLogInProcess(false)
              resolve({ success: true, msg: 'is Logged in', data: res2 })
            })
          })
          .catch((error) => {
            console.error(
              'fetchServiceConfiguration() had some problems !',
              error
            )
            reject({ error: true, errorMsg: error.toString() })
            throw new Error(
              'idPortenAppAuth.fetchServiceConfiguration() had some problems ! ' +
                error
            )
          })
      } else {
        resolve({ success: false, waiting: true })
      }
    }) // promise
  },
  async feideLogin() {
    console.log('feideLogin got called !')
    return new Promise((resolve, reject) => {
      // login() // v1..
      // appAuth = new AppAuth()
      feideAppAuth
        .fetchServiceConfiguration()
        .then((res) => {
          console.log(
            '=== feideLogin appAuth.fetchServiceConfiguration() returned'
          )
          console.log(res)
          feideAppAuth.makeAuthorizationRequest().then((res2) => {
            console.log('makeAuthorizationRequest returned (' + res2 + ')')
            //            appAuth.checkForAuthorizationResponse()
            resolve({ success: true, msg: 'is Logged in', data: res2 })
          })
        })
        .catch((error) => {
          console.error(
            'fetchServiceConfiguration() had some problems !',
            error
          )
          reject({ success: false, error: true, errorMsg: error.toString() })
          throw new Error(
            'feideAppAuth.fetchServiceConfiguration() had some problems ! ' +
              error
          )
        })
    }) // promise
  },
  checkSSO() {
    console.log('authSSO got called !')
    return new Promise((resolve, reject) => {
      if (this.feideLoggedIn) {
        resolve({ success: true, msg: 'is Logged in' })
      } else {
        feideAppAuth
          .silentSigning()
          .then((res) => {
            console.log('SILENT SIGNING returned (%J)', res)
            resolve(res)
          })
          .catch((err) => {
            console.log('ERROR SILENT SIGNING returned (' + err + ')')
            reject(err)
          })
      }
    }) //promise
  },
  async clientLogout() {
    await this.logout()
  },
  async logout() {
    console.log('LOGOUT got called !')
    return new Promise((resolve, reject) => {
      idPortenAppAuth.logout().then((res) => {
        console.log('LOGOUT idPortenAppAuth.logout() returned')
        console.log(res)
        //resolve({ success: true, msg: 'is Logged out', data: res })
      })
      feideAppAuth.signOut().then((res) => {
        console.log('LOGOUT feideAppAuth.signOut() returned')
        console.log(res)
        //resolve({ success: true, msg: 'is Logged out', data: res })
      })

      resolve('ok')
    }) // promise
  },
  setLoggedIn(payload) {
    this.loggedIn = payload
  },
  setFeideLoggedIn(payload) {
    this.feideLoggedIn = payload
  },
  async idPortenCallback(payload) {
    console.log('idPortenCallback got called ! %j', payload)
    return new Promise((resolve, reject) => {
      this.fixServerURL()
      idPortenAppAuth.setCodeStatus(payload.callbackCode, payload.callbackState)
      idPortenAppAuth.checkForAuthorizationResponse().then((res) => {
        console.log(
          '====== GOT checkForAuthorizationResponse ====== (' + res + ')'
        )
        idPortenAppAuth
          .fetchServiceConfigurationToken(
            payload.callbackCode,
            payload.callbackState
          )
          .then((result) => {
            console.log('==== fetchServiceConfigurationToken RESULT : ')
            console.log(result)

            let accessToken = result.accessToken
            //  let tokenExpiresIn = result.expiresIn  // not used...
            let idToken = result.idToken
            var decoded = jwt.decode(idToken)
            console.log('==== DECODED (%J)', decoded)
            let tokenExpires = decoded.exp
            let extTime = dayjs.unix(tokenExpires)
            console.log('TOKEN EXPIRES (%s)', extTime.utc().format())
            this.accessToken = accessToken
            this.accessTokenExpires = extTime
            this.idtoken = idToken
            this.refreshToken = result.refreshToken
            localStorage.setItem('tokenexpire', tokenExpires)
            resolve(accessToken)

            //     resolve('OK')
          })
          .catch((error) => {
            console.error('*** ERROR *** CALLBACK : ' + error)
            reject({
              errorMsg: '*** ERROR *** CALLBACK : ' + error
            })
          })
      }) // checkForAuthorizationResponse
    }) // promise
  },
  async feideCallback(payload) {
    console.info(
      'feideCallback CALLBACK got called !' + JSON.stringify(payload)
    )
    return new Promise((resolve, reject) => {
      this.fixServerURL()
      feideAppAuth.checkForAuthorizationResponse().then((res) => {
        console.log(
          '====== GOT checkForAuthorizationResponse ====== (' + res + ')'
        )
        feideAppAuth.setCodeStatus(payload.callbackCode, payload.callbackState)
        feideAppAuth
          .fetchServiceConfigurationToken(
            payload.callbackCode,
            payload.callbackState
          )
          .then((result) => {
            console.log('==== fetchServiceConfigurationToken RESULT : ')
            console.log(result)
            if (result.error) {
              toast.warning(t('toast.errorlogon'))
              this.clientLogout().finally(() => {
                router.push({ name: 'MustLogin' }).catch(() => {})
              })
            } else if (result.success) {
              console.info('==== CALLBACK RESULT : ')
              console.info(result)

              let accessToken = result.accessToken
              //  let tokenExpiresIn = result.expiresIn  // not used...
              let idToken = result.idToken
              var decoded = jwt.decode(idToken)
              // console.log('==== DECODED (%J)', decoded)
              let tokenExpires = decoded.exp
              let extTime = dayjs.unix(tokenExpires)
              // console.log('TOKEN EXPIRES (%s)', extTime.utc().format())
              this.accessToken = accessToken
              this.accessTokenExpires = extTime
              this.idtoken = idToken
              localStorage.setItem('tokenexpire', tokenExpires)
              resolve(accessToken)
            }
            //     resolve('OK')
          })
          .catch((error) => {
            console.error('*** ERROR *** CALLBACK : ' + error)
            reject({
              errorMsg: '*** ERROR *** CALLBACK : ' + error
            })
          })
      }) // checkForAuthorizationResponse
    }) // promise
  },
  async settingEduParams() {
    //  this.$info('=== setEduParams got called ! ')
    console.info('Setting edu params')
    return new Promise((resolve) => {
      this.setProgress(10, t('loading.txt3'))
      let token = this.accessToken
      let idToken = this.idToken
      let feide = new FeideTools(token, idToken)
      let redirect = ''
      let payload = {}
      feide
        .getBasicUserInfo()
        .then((res) => {
          this.setProgress(30, t('loading.txt4'))
          // console.log('LOGGED IN / Get USER INFO res: getBasicUserInfo: ')
          // console.log(res)
          payload.displayName = res.displayName
          payload.name = res.name
          payload.eduPersonPrimaryAffiliation = this.getAffiliations(
            'faculty',
            res
          )
          payload.eduPersonPrincipalName = res.eduPersonPrincipalName
          payload.eduPersonAffiliation = res.eduPersonAffiliation
          payload.accessToken = token
          if (!this.isFaculty(payload)) {
            //            throw new Error("User not Educator/Faculty");
            console.log(
              '++++++++++++++++ WE DO NOT HAVE EDUCATOR ++++++ (%j)',
              payload
            )

            this.clientLogout()
            resolve({
              success: false,
              error: true,
              errorMsg: 'User not Educator/Faculty'
            })
          }
          this.setProgress(40, t('loading.txt4'))
          feide
            .getUserInfo() // auth.dataporten.no/openid/userinfo
            .then((result) => {
              this.setProgress(50, t('loading.txt5'))
              // console.log('GetUserInfo')
              // console.log(result)
              //              payload.userid = result.user.userid
              payload.userid = result['dataporten-userid_sec'][0]
              // payload.name = result.user.name
              // payload.picture = result.user.picture
              payload.name = result.name
              payload.picture = result.picture
            })
            .catch((error) => {
              console.error('*** ERROR *** getUserInfo: ' + error)
            })
          // console.log('= = = = = = Getting All GROUPS')
          this.setProgress(60, t('loading.txt5'))
          feide
            .getAllGroups()
            .then((result) => {
              // console.log('getAllGroups')
              // console.log(result)
              payload.allGroups = result
              this.setProgress(70, t('loading.txt6'))
              /* setFeideUserInfo also creates the encrypted serverAccessToken */
              payload.encodedAccessToken = encodeLoad(token)

              this.setFeideUserInfo(payload)
                .then((result) => {
                  console.log('======= SET FEIDE USER INFO GOT (%)', result)
                  //                  console.log(result)
                  //                  console.log('== RESULT NO SCHOOL (' + result.noschool + ')')
                  this.setProgress(75, t('loading.txt6a'))
                  // collecting data about the learner, subject etc.
                  this.findEducatorInfo(payload)
                    .then((result) => {
                      if (result.nodata) {
                        //  console.log('== Find EDUCATOR INFO: had some problems')
                        redirect = 'nodata'
                      }
                      if (result.error) {
                        //     console.log('== FIND EDUCATOR INFO: had some errors')
                        //     console.log(result.error)
                        redirect = 'nodata'
                      }
                      //    console.log('findEducatorInfo')
                      //    console.log(result)
                      //  this.setProgress(80, t('loading.txt6'))
                      // this.setProgress(80, t('loading.txt6b'))
                      // this.setProgress(80, this.$t("loading.txt6b"))
                    })
                    .catch((error) => {
                      console.warn(
                        '*** ERROR *** findEducatorInfo had some problems ',
                        JSON.stringify(error)
                      )
                      console.log(error)
                      redirect = 'nodata'
                    })
                    .finally(() => {
                      console.log(
                        '================== F I N A L L Y =========== (' +
                          redirect +
                          ')'
                      )
                      this.setProgress(90, t('loading.txt7'))
                      if (!this.isFaculty(payload)) {
                        console.error(
                          'Wrong affiliation - sending error message'
                        )
                        toast.error(t('loggedin.noeducator'))
                        resolve({
                          success: false,
                          error: true,
                          errorMsg: 'User not Educator/Faculty'
                        })
                      }
                      let errHeading = ''
                      let errTxt = ''
                      switch (redirect) {
                        case 'noschool':
                          resolve({
                            success: false,
                            error: true,
                            errorMsg: 'No School...'
                          })
                          break
                        case 'errorfeideuser':
                          resolve({
                            success: false,
                            error: true,
                            errorMsg: 'Problem with feide user...'
                          })
                          break
                        case 'errorcatchfeide':
                          resolve({
                            success: false,
                            error: true,
                            errorMsg: 'Feide error...'
                          })
                          break
                        case 'error':
                          resolve({
                            success: false,
                            error: true,
                            errorMsg: 'GENERIC PROBLEM - ERROR'
                          })
                          break
                        case 'nodata':
                          /* Then we try to populate the educatorInfor one more time. In some situations we loos the subjects when creating new educators... */
                          console.log('____ NO DATA ___')
                          resolve({
                            success: false,
                            error: true,
                            errorMsg: 'NO DATA...'
                          })
                          break
                        default:
                          console.log(
                            '-------------- MOVING TO START PAGE ------------ (%s)',
                            this.getLicense()
                          )
                          this.setFeideLoggedIn(true)
                          this.logIsLoggedIn(payload.displayName)
                          this.encryptSessionInfoForSSO()
                          if (this.getLicense()) {
                            this.setFeideLoggedIn(true)
                            resolve({
                              success: success,
                              error: false
                            })
                          } else {
                            // nolicense
                            resolve({
                              success: false,
                              error: true,
                              errorMsg: 'NO LICENSE...'
                            })
                          }
                          break
                      }
                    }) // finally
                })
                .catch((error) => {
                  //    console.log('===== ERROR ======')
                  //    console.log(error)
                  redirect = 'errorcatchfeide'
                  // console.error('setFeideUserInfo had some problems : ' + error)
                  resolve({
                    success: false,
                    error: true,
                    errorMsg: 'CATCH ERROR...'
                  })
                })
            }) // getAll Groups
            .catch((error) => {
              console.error(
                '*** ERROR *** getAllGroups had some problems : ' + error
              )
              let errHeading = t('loggedin.feideerrorheader')
              let errTxt = t('loggedin.feideerrortxt') + ' ' + error
              redirect = 'errorcatchfeide'
              resolve({
                success: false,
                error: true,
                errorMsg: 'CATCH FEIDE ERROR...'
              })
            })
        })
        .catch((error) => {
          console.error(
            '*** ERROR *** getBasicUserInfo had some problems !' + error
          )
          resolve({
            success: false,
            error: true,
            errorMsg: 'FINAL CATCH PROBLEM 123132-2321'
          })
        })
    }) // promise
  },
  setFeideUserInfo(payload) {
    // profilephoto: https://api.dataporten.no/userinfo/v1/user/media/
    // let feideTools = new FeideTools()
    let uStore = new userStore()
    let newUser = false
    return new Promise((resolve, reject) => {
      console.log('setFeideUserInfo got called : (%j)', payload)
      this.setDisplayName(payload.displayName)
      this.setAffiliation(payload.eduPersonAffiliation)
      this.setPicture(payload.picture)
      payload.orgNIN = getOrgNIN(payload.allGroups[1].id)
      uStore.setFeideUser(payload)
      payload.serviceServerUrl = this.serverUrl
      let tokenPayload = {
        accessToken: payload.accessToken,
        displayName: payload.displayName,
        eduPersonPrimaryAffiliation: payload.eduPersonPrimaryAffiliation,
        encodedAccessToken: payload.encodedAccessToken,
        name: payload.name,
        serviceServerUrl: payload.serviceServerUrl,
        userid: payload.userid
      }
      this.createJwtTokenForClient(tokenPayload)
        .then((result) => {
          // NOTE: DELETED CHECKING FOR CREATION OF EDUCATOR ETC ETC.
          // To be found in V4L Codebank...
          // last part of the token is the secret key..
          console.log('createJwtTokenForClient returned (%j)', result)
          this.setServerAccessToken(result.accessToken)
          this.setPublicKey(result.publicKey)
          this.setAppSecret(result.secret)
          this.setSid(result.sid)
          localStorage.setItem('sid', result.sid)
          localStorage.setItem('ssa', result.accessToken)
          //  let secret = result.secret
          //  $cookies.set('secretuuid', secret, '1d', '/', '.ataa.no', true)
          console.log('createJwtTokenForClient returned')
          console.log(result)
          this.feideLoggedIn = true
          resolve({ success: true, error: false })
          // })
          // .then(() => {
        }) // then() createJWT token
        .catch((errorjwt) => {
          console.error(
            '*** ERROR *** createJWT Token For Client had some problems : ',
            errorjwt
          )
          reject({
            success: false,
            error: true,
            errorMsg:
              '*** ERROR *** createJWT Token For Client had some problems : ',
            errorjwt
          })
        })
    }) // promise
  },
  checkLicense(payload) {
    return new Promise((resolve) => {
      // FOR PROTOTYPING...
      this.setLicense(true)
      resolve({
        success: true,
        message: 'We have license',
        hasLicense: true,
        noLicense: false
      })
      /*
      let orgData = {}
      console.log('CHECK LICENSE GOT CALLED :' + JSON.stringify(payload))
      let groups = payload.allGroups || []
      for (let i = 0; i < groups.length; i++) {
        let group = groups[i]
        //  console.log('GROUP ER:' + JSON.stringify(group))
        let groupOrgType = ''
        if (group.orgType) {
          groupOrgType = group.orgType[0]
        }
        console.log('GROUP ORG TYPE: (%s)', groupOrgType)
        if (groupOrgType !== '') {
          switch (groupOrgType) {
            case 'higher_education':
              orgData.schoolName = group.displayName
              orgData.schoolNorEduOrgNin = group.norEduOrgNIN
              console.log('GOT HIGHER EDUCATION (%j)', orgData)
              break
            case 'primary_and_lower_secondary_owner':
              orgData.municipalityName = group.displayName
              // orgData.municipalityNorEduOrgNin = group.norEduOrgNIN
              orgData.schoolNorEduOrgNin = group.norEduOrgNIN
              console.log('GOT SCHOOL/HE OWNER ' + JSON.stringify(orgData))
              break
            case 'primary_and_lower_secondary':
              orgData.schoolName = group.displayName
              orgData.schoolNorEduOrgNin = getOrgNIN(group.id)
              console.log('GOT SCHOOL ' + JSON.stringify(orgData))
              break
            default:
              console.log('GOT DEFAULT (%s)', groupOrgType)
          }
        }
      } // for
      let schoolNIN = orgData.schoolNorEduOrgNin
      let load = `{
           query(func: eq(school_norEduOrgNIN, "${schoolNIN}")) @cascade {
              uid
              school_has_license
              school_norEduOrgNIN
           }
       } `
      let pLoad = {
        query: encodeLoad(load),
        p1: this.sid
      }
      console.log('PLOAD ER: (%j)', pLoad)
      this.postHTTP('dgraph-api/dquery/hypatiaCheckLicense', pLoad)
        .then((response) => {
          console.log(
            '============================ CHECK LICENSE RESPONSE ER ======='
          )
          console.log(JSON.stringify(response.data))
          let responseData = response.data.dgraphresult[0] || {}
          console.log(JSON.stringify(responseData))
          console.log(
            'LOGIC CHECK(' +
              (responseData.school_norEduOrgNIN === schoolNIN) +
              ')'
          )
          console.log('NIN(%s) UID(%s)', schoolNIN, responseData.uid)
          console.log(
            'LOGIC CHECK2 (' + (responseData.school_has_license !== '') + ')'
          )
          console.log(responseData.school_has_license)
          if (
            responseData.school_norEduOrgNIN === schoolNIN &&
            responseData.school_has_license !== ''
          ) {
            this.setLicense(true)
            resolve({
              success: true,
              message: 'We have license',
              hasLicense: true,
              noLicense: false
            })
          } else {
            // No license information registered
            this.setLicense(false)
            resolve({
              success: false,
              error: true,
              errorMsg: 'No license for school :' + orgData.schoolName,
              hasLicense: false,
              noLicense: true
            })
          }
        })
        .catch((error) => {
          this.setLicense(false)
          console.error(
            '*** ERROR **** checkLicense had some problems ! : ' + error
          )
          resolve({
            success: false,
            error: true,
            errorMsg: 'No license for school :' + orgData.schoolName,
            hasLicense: false,
            noLicense: true
          })
        })
    */
    }) // promise
  },
  getAffiliations(role, payload) {
    console.log('getAffliations got called')
    console.log(payload)
    let affiliations = payload.eduPersonAffiliation
    for (let i = 0; i < affiliations.length; i++) {
      if (affiliations[i].toLowerCase() === role) {
        return role
      }
    }
    return 'NOT A STUDENT ROLE'
  },
  isFaculty(payload) {
    console.log('isFaculty got called')
    console.log(payload)
    if (
      payload.eduPersonPrimaryAffiliation.toLowerCase() === 'employee' ||
      payload.eduPersonPrimaryAffiliation.toLowerCase() === 'faculty' ||
      payload.eduPersonPrimaryAffiliation.toLowerCase() === 'staff'
    ) {
      let affiliations = payload.eduPersonAffiliation
      let affiliationValue = false
      affiliations.forEach((item) => {
        // console.log('==== ITEM =====(' + item + ')')
        if (
          item.toLowerCase() === 'faculty' ||
          item.toLowerCase() === 'employee' ||
          item.toLowerCase() === 'staff'
        ) {
          console.log('++++++++++++++++ WE HAVE FACULTY/EDUCATOR ++++++')
          affiliationValue = true
        }
      })
      return affiliationValue
    }
    let affiliations = payload.eduPersonAffiliation
    //  this.$info('eduPersonAffiliation', payload.eduPersonAffiliation)
    affiliations.find((value) => {
      //    console.log('==== VALUE(' + value + ')')
      if (value === 'faculty' || value === 'employee' || value === 'staff') {
        return true
      }
    })

    // We found a match.
    //  console.log('++++++++++++++++ WE HAVE STUDENT ++++++')
    console.log('++++++++++++++++ WE HAVE _N O_ EDUCATOR ++++++')
    return false
  },
  setProgress(position, stringValue) {
    console.log('SET PROGRESS CALLED (%s) (%s)', position, stringValue)
  },
  fixServerURL() {
    console.log(
      '--------------- fixServerURL got called ! (%s)',
      this.serverUrl
    )
    let serverUrl = this.serverUrl
    if (serverUrl === undefined || serverUrl === '') {
      this.registryUrl = localStorage.getItem('hypregistry')
      this.serverUrl = localStorage.getItem('hypsaserver')
      console.log('--------------- setServer and setRegistry got called !')
    }
  },
  /* *************************************** */
  /*        FETCH HTTP                       */
  /* *************************************** */
  async postHTTPLong(url, loadData) {
    return new Promise((resolve, reject) => {
      let accessClientToken = this.serverAccessToken
      let serverUrl = this.serverUrl || localStorage.getItem('hypsaserver')
      console.log('postHTTPLong URL (%s)', checkRegistryURL(serverUrl) + url)
      let options = {
        method: 'POST',
        url: checkRegistryURL(serverUrl) + url,
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'cors',
        credentials: 'include',
        responseType: 'json', // default
        responseEncoding: 'utf8', // default
        maxRedirects: 3, // default
        'Accept-Encoding': 'gzip, compress',
        body: JSON.stringify(loadData),
        headers: {
          Authorization: `Bearer ${accessClientToken}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
          lhclient: 'bettereducationforall' // for Cloud armor firewall rules
        }
      }
      fetch(options.url, options)
        .then((response) => {
          console.log('POST LONG HTTP RESPONSE (%J)', response)
          console.log(response)
          response
            .json()
            .then((result) => {
              console.log('DATA (%j)', result)
              resolve({ success: true, data: result })
            })
            .catch((err) => {
              console.error('FETCH JSON', err)
            })
        })
        .catch((error) => {
          console.error('*** ERROR *** postHTTPLong', {
            errorMsg: error.toString()
          })
          reject({ success: false, error: true, errorMsg: error.toString() })
        })
    }) // promise
  },
  async postHTTP(url, loadData) {
    //  console.log('postHTTP got called (%s) (%s)',this.serverurl , url)
    return new Promise((resolve, reject) => {
      let accessClientToken = this.serverAccessToken
      let serverUrl = this.serverurl || localStorage.getItem('hypsaserver')
      // console.log('postHTTP URL (%s)', checkRegistryURL(serverUrl) + url,)
      // console.log('LoadDATA (%j)', JSON.stringify(loadData))
      let options = {
        method: 'POST',
        url: checkRegistryURL(serverUrl) + url,
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'cors',
        // credentials: "include",
        timeout: 30000, // 3min
        responseType: 'json', // default
        responseEncoding: 'utf8', // default
        maxRedirects: 3, // default
        'Accept-Encoding': 'gzip, compress',
        body: JSON.stringify(loadData),
        headers: {
          Authorization: `Bearer ${accessClientToken}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
          lhclient: 'bettereducationforall' // for Cloud armor firewall rules
        }
      }
      //  console.log('postHTTP URL (%s)', options.url)
      fetch(options.url, options)
        .then((response) => {
          //  console.log('POST HTTP RESPONSE (%J)', response)
          //  console.log(response)
          response
            .json()
            .then((result) => {
              //   console.log('DATA (%j)', result)
              resolve({ success: true, data: result })
            })
            .catch((err) => {
              console.error('FETCH JSON', err)
            })
        })
        .catch((error) => {
          console.error('*** ERROR *** postHTTP', {
            errorMsg: error.toString()
          })
          reject({ success: false, error: true, errorMsg: error.toString() })
        })
    }) // promise
  },
  async getHTTP(url) {
    return new Promise((resolve, reject) => {
      let accessClientToken = this.serverAccessToken
      let serverUrl = this.serverUrl || localStorage.getItem('hypsaserver')
      console.log('GET HTTP URL (%s)', checkRegistryURL(serverUrl) + url)
      let options = {
        method: 'GET',
        url: checkRegistryURL(serverUrl) + url,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          lhclient: 'bettereducationforall' // for Cloud armor firewall rules
        },
        mode: 'cors',
        // timeout: 30000, // 30s // controlled by the browser
        responseType: 'json', // default
        responseEncoding: 'utf8', // default
        maxRedirects: 3, // default
        'Accept-Encoding': 'gzip, compress'
        // body: "{foo: 'bar'}" //JSON.stringify(loadData),
      }

      fetch(options.url, options)
        .then((response) => {
          //   console.log('RESPONSE IS (%j)', response)
          response
            .json()
            .then((result) => {
              //   console.log('RESULT FROM JSON IS (%j)', result)
              resolve({ success: true, data: result })
            })
            .catch((err2) => {
              console.error('RESPONSE JSON', err2)
            })
        })
        .catch((error) => {
          console.error('*** ERROR *** getHTTP', { errorMsg: error.toString() })
          reject({ success: false, error: true, errorMsg: error.toString() })
        })
    }) // promise
  },
  async getHTTPSimple(url) {
    return new Promise((resolve, reject) => {
      let accessClientToken = this.serverAccessToken
      let serverUrl = this.serverUrl || localStorage.getItem('hypsaserver')

      console.log('GET getHTTPSimple URL (%s)', url)
      let options = {
        method: 'GET',
        url: checkRegistryURL(serverUrl) + url,
        headers: {
          //  'Content-Type': 'application/json'
        },
        mode: 'cors',
        // timeout: 30000, // 30s // controlled by the browser
        responseType: 'json', // default
        responseEncoding: 'utf8', // default
        maxRedirects: 3, // default
        'Accept-Encoding': 'gzip, compress'
        // body: "{foo: 'bar'}" //JSON.stringify(loadData),
      }
      fetch(options.url, options)
        .then((response) => {
          //    console.log('RESPONSE IS (%j)', response)
          response
            .json()
            .then((result) => {
              //     console.log('RESULT FROM JSON IS (%j)', result)
              resolve({ success: true, data: result })
            })
            .catch((err2) => {
              console.error('RESPONSE JSON', err2)
            })
        })
        .catch((error) => {
          console.error('*** ERROR *** getHTTPSimple', {
            errorMsg: error.toString()
          })
          reject({ success: false, error: true, errorMsg: error.toString() })
        })
    }) // promise
  },
  async getHTTPSimpleRegistry(url) {
    // Expecting a complete URL, no prefix with server
    return new Promise((resolve, reject) => {
      let accessClientToken = this.serverAccessToken
      console.log('GET getHTTPSimple URL (%s)', url)
      let options = {
        method: 'GET',
        url: url,
        headers: {
          //  'Content-Type': 'application/json'
        },
        mode: 'cors',
        // timeout: 30000, // 30s // controlled by the browser
        responseType: 'json', // default
        responseEncoding: 'utf8', // default
        maxRedirects: 3, // default
        'Accept-Encoding': 'gzip, compress'
        // body: "{foo: 'bar'}" //JSON.stringify(loadData),
      }
      fetch(options.url, options)
        .then((response) => {
          //    console.log('RESPONSE IS (%j)', response)
          response
            .json()
            .then((result) => {
              //     console.log('RESULT FROM JSON IS (%j)', result)
              resolve({ success: true, data: result })
            })
            .catch((err2) => {
              console.error('RESPONSE JSON', err2)
            })
        })
        .catch((error) => {
          console.error('*** ERROR *** getHTTPSimple', {
            errorMsg: error.toString()
          })
          reject({ success: false, error: true, errorMsg: error.toString() })
        })
    }) // promise
  },
  async setSchema(payload) {
    console.log('updateSchema got called ! (%j)', payload)
    return new Promise((resolve, reject) => {
      //let serverUrl = this.serverUrl
      let pLoad = {
        p1: this.sid,
        gogl: true
      }
      this.postHTTP('dgraphschema/setschema')
        .then((response) => {
          console.log('setSchema response: ')
          resolve(response)
        })
        .catch((error) => {
          console.error('updateSchema had an error: ', error)
          reject(new Error('updateSchema had an error: ', error))
        })
    }) // promise
  },
  async getAllKindergartens(payload) {
    return new Promise((resolve) => {
      this.postHTTP('lhadmin/getallkindergartens/allk')
        .then(
          (result) => {
            console.log('GET ALL KINDERGARTENS (%j)', result)
            let resData = result.data || {}
            let dgraphRes = resData.dgraphresult || {}
            console.log('DGRAPH RES (%s) (%j)', dgraphRes.success, dgraphRes)
            let dgraphData = dgraphRes.data || {}
            console.log('DGRAPH DATA (%j)', dgraphData)
            if (dgraphRes.noresult) {
              resolve({ success: false, noresult: true })
            } else if (dgraphRes.success) {
              let dQuery = dgraphData.query || []
              resolve({ success: true, data: dQuery })
            } else {
              resolve({
                success: false,
                error: true,
                errorMsg: dgraphRes.errorMsg
              })
            }
            // resolve({success: true, data: result})
          } // postHTTP
        )
        .catch((error) => {
          console.error(
            'admin ACTIONS GET GUARDIAN INFORMATION ERROR (%j)',
            error
          )
          resolve({ success: false, error: true, errorMsg: error.toString() })
        })
    }) // promise
  },
  async getAllManagerKindergartens(payload) {
    console.log('getAllManagerKindergartens called (%j)', payload)
    return new Promise((resolve) => {
      let pLoad = {
        mutate: encodeLoad(JSON.stringify(payload))
      }
      this.postHTTP('lhadmin/getallmanagerkindergartens/allm', pLoad)
        .then(
          (result) => {
            console.log('GET ALL Manager KINDERGARTENS (%j)', result)
            let resData = result.data || {}
            let dgraphRes = resData.dgraphresult || {}
            console.log('DGRAPH RES (%s) (%j)', dgraphRes.success, dgraphRes)
            let dgraphData = dgraphRes.data || {}
            console.log('DGRAPH DATA (%j)', dgraphData)
            if (dgraphRes.noresult) {
              resolve({ success: false, noresult: true })
            } else if (dgraphRes.success) {
              let dQuery = dgraphData.query || []
              resolve({ success: true, data: dQuery })
            } else {
              resolve({
                success: false,
                error: true,
                errorMsg: dgraphRes.errorMsg
              })
            }
            // resolve({success: true, data: result})
          } // postHTTP
        )
        .catch((error) => {
          console.error(
            'admin ACTIONS GET GUARDIAN INFORMATION ERROR (%j)',
            error
          )
          resolve({ success: false, error: true, errorMsg: error.toString() })
        })
    }) // promise
  },
  async getKindergartensChildren(payload) {
    console.log('getKindergartensChildren called (%j)', payload)
    return new Promise((resolve) => {
      let pLoad = {
        mutate: encodeLoad(JSON.stringify(payload))
      }
      this.postHTTP('lhadmin/getallkindergartenschildren/allchildren', pLoad)
        .then(
          (result) => {
            console.log('GET ALL Manager KINDERGARTENS (%j)', result)
            let resData = result.data || {}
            let dgraphRes = resData.dgraphresult || {}
            console.log('DGRAPH RES (%s) (%j)', dgraphRes.success, dgraphRes)
            let dgraphData = dgraphRes.data || {}
            console.log('DGRAPH DATA (%j)', dgraphData)
            if (dgraphRes.noresult) {
              resolve({ success: false, noresult: true })
            } else if (dgraphRes.success) {
              let dQuery = dgraphData.query || []
              resolve({ success: true, data: dQuery })
            } else {
              resolve({
                success: false,
                error: true,
                errorMsg: dgraphRes.errorMsg
              })
            }
            // resolve({success: true, data: result})
          } // postHTTP
        )
        .catch((error) => {
          console.error(
            'admin ACTIONS GET GUARDIAN INFORMATION ERROR (%j)',
            error
          )
          resolve({ success: false, error: true, errorMsg: error.toString() })
        })
    }) // promise
  },
  setCallback(payload) {
    this.callback = payload
  },
  setCallbackState(payload) {
    this.callbackstate = payload
  },
  setLicense(payload) {
    this.license = payload
  },
  setDisplayName(payload) {
    let uStore = userStore()
    this.displayname = payload
    uStore.displayName = payload
  },
  setAffiliation(payload) {
    this.affiliation = payload
  },
  setPicture(payload) {
    this.picture = payload
  },
  setSid(payload) {
    this.sid = payload
  },
  setServerAccessToken(payload) {
    this.serveraccesstoken = payload
  },
  setPublicKey(payload) {
    this.publickey = payload
  },
  setAppSecret(payload) {
    this.appsecret = payload
  },
  /* *** FUNCTIONS *** */
  async createJwtTokenForClient(payload) {
    console.info('<<<<<<<<< createJwtTokenForClient got called')
    console.info(payload)
    return new Promise((resolve, reject) => {
      try {
        let tokenPayload = {
          userid: payload.userid,
          affiliation: payload.eduPersonAffiliation,
          accessToken: payload.encodedAccessToken,
          payload: payload
          //  expires: payload.expires
        }
        console.log('tokenPayload : %j', tokenPayload)
        this.getServerSecret()
          .then((result) => {
            console.info('GET SERVER SECRET RETURNED : (%j)', result)
            let publicKey = result.publicKey
            let serverSecret = result.secret
            this.setSid(result.sid)
            tokenPayload.serverSecret = result.secret
            tokenPayload.sessionid = result.sid
            let hypJWE = new CreateHypatiaJWE(
              tokenPayload,
              serverSecret,
              null,
              publicKey
            )
            let encrypted = ''

            hypJWE
              .setUp()
              .then(() => {
                hypJWE
                  .encrypt(JSON.stringify(tokenPayload))
                  .then((encrypts) => {
                    encrypted = encrypts
                    console.log(tokenPayload)
                    console.log('==== ENCRYPTED ====')
                    console.log(encrypted)
                  })
                  .then(() => {
                    let cryptedPayload = {
                      cryptedPayload: encrypted
                    }
                    console.log('CRYPTED PAYLOAD (%s)', result.sid)
                    console.log(cryptedPayload)
                    hypJWE.sign(cryptedPayload, serverSecret).then((token) => {
                      resolve({
                        encryptedPayload: encrypted,
                        accessToken: token,
                        publicKey: publicKey,
                        secret: serverSecret,
                        sid: result.sid
                      })
                    }) // sign
                  }) // encrypt
                  .catch((error) => {
                    console.error(
                      '*** ERROR *** problems encrypting the payload : ' + error
                    )
                    reject({
                      error: true,
                      errorMsg:
                        '*** ERROR *** problems encrypting the payload : ' +
                        error
                    })
                  }) // encrypt catch
              }) // setup
              .catch((error) => {
                console.error(
                  '*** ERROR *** hypJWE.setup had some problems',
                  error
                )
                reject(
                  new Error(
                    '*** ERROR *** hypJWE.setup had some problems',
                    error
                  )
                )
              })
            /*
            hypJWE.decrypt(encrypted)
              .then(decrypted => {
                console.log('==== DECRYPTED ====')
                console.log(decypted)
              })
              */
          }) // secret
          .catch((error) => {
            console.error(
              '*** ERROR *** problems getting the secret from the server : ' +
                error
            )
            reject({
              error: true,
              errorMsg:
                '*** ERROR *** problems getting the secret from the server : ' +
                error
            })
          }) // getServerSecret - catch
      } catch (error) {
        console.error(
          '*** ERROR **** createJwtTokenForClient, had some problems ' + error
        )
        reject({
          errorMsg:
            '*** ERROR **** createJwtTokenForClient, had some problems ' + error
        })
      }
    }) // promise
  },
  async getServerSecret() {
    //  console.log('GET SERVER Secret GOT CALLED !')
    //  console.log('=== getServerSecret ')
    return new Promise((resolve, reject) => {
      this.getHTTP('sysinfo/jwtsecret')
        .then((result) => {
          console.log('JwtSecret er: (%j)', result)
          //  localStorage.setItem('hypsaserversecret', result.data.secret)
          console.log('publicKey: ' + result.data.publicKey)
          resolve(result.data) // {'secret': something }
        })
        .catch((error) => {
          console.error('*** ERROR *** getServerSECRET had some errors:', error)
          reject(
            new Error({
              error: error
            })
          )
        })
    }) // promise
  }
}

/* Parses the string 'fc:org:spusers.feide.no:unit:NO856326499' and returns NO856326499 */
function getOrgNIN(orgNin) {
  let strSplit = orgNin.split(':')
  if (strSplit.length !== 5) {
    console.error('WRONG NUMBER OF PARAMS IN getOrgNIN !')
    throw new Error('WRONG NUMBER OF PARAMS IN getOrgNIN  ')
  }
  return strSplit[4]
}
